import { render, staticRenderFns } from "./Editable.vue?vue&type=template&id=67a5a3b0&scoped=true&"
import script from "./Editable.vue?vue&type=script&lang=ts&"
export * from "./Editable.vue?vue&type=script&lang=ts&"
import style0 from "./Editable.vue?vue&type=style&index=0&id=67a5a3b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a5a3b0",
  null
  
)

export default component.exports